/* eslint-disable import/no-unresolved */
import React, { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { swalMessages } from '@auteco/constants';
import swal from 'sweetalert';
import { Context } from 'src/context/Contex';
import filterArray from 'src/utils/filterArray';
import BossesPage from 'src/pages/PolygonsPage/BossesPage/BossesPage';
import polygonsService from 'src/services/polygonsService';
import { loaderService } from 'src/services/loaderService';

const BossesContainer = () => {
  const [jefes, setJefes] = useState('');
  const [select, setSelect] = useState('');
  const [search, setSearch] = useState('');
  const [jefesTerritorios, SetjefesTerritorios] = useState([]);
  const [territorios, setTerritorios] = useState([]);
  const [searchBosses, setSearchBosses] = useState('');

  const { unidad, permisos } = useContext(Context);
  const history = useHistory();
  const dataTable = [];

  /*= =======================================================================
  Get Jefes
======================================================================== */
  const getBosses = () => {
    polygonsService
      .getJefes(unidad)
      .then((response) => {
        setJefes(response.data.data);
      })
      .catch((error) => {
        console.log(error);
        history.push('/home');
      });
  };

  /*= =======================================================================
  Get Territorio y Jejes
======================================================================== */
  const getTerritoriesBosses = () => {
    polygonsService
      .getJefesTerritorios(unidad)
      .then((response) => {
        SetjefesTerritorios(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /*= =======================================================================
  Get Territorios
======================================================================== */
  const getTerritories = async () => {
    const response = await polygonsService.getTerritorios(unidad);
    setTerritorios(response);
  };

  useEffect(() => {
    Promise.all([getBosses(), getTerritories(), getTerritoriesBosses()]).then(
      () => {
        loaderService.hide();
      },
    );
    loaderService.show();
  }, [unidad]);

  /*= =======================================================================
 Post Jefes
======================================================================== */
  const handleCreateBosses = (params) => {
    polygonsService
      .postJefe({ nombre: params.value, unidad_negocio_id: unidad })
      .then((response) => {
        if (response.data.id === 0) {
          swal(swalMessages.REPEAT_MESSAGE_ERROR);
        } else {
          getBosses();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /*= =======================================================================
  Editar Jefes
======================================================================== */
  const handleUpdate = (params) => {
    polygonsService
      .putJefe(params)
      .then((response) => {
        if (response.data.id === 0) {
          swal(swalMessages.ASSIGNMENT_ESTABLICHED);
        } else {
          setSelect(params);
          getBosses();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /*= =======================================================================
  Eliminar Jefes
======================================================================== */
  const handleDelete = (params) => () => {
    swal(swalMessages.DELETE_CONFIRM).then((willDelete) => {
      if (willDelete) {
        polygonsService
          .deleteJefe(params)
          .then((response) => {
            if (response.data.id === 0) {
              swal(swalMessages.DELETE_ERROR);
            } else {
              getBosses();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };

  /*= =======================================================================
Asignar Territorios a Jefes
======================================================================== */
  const handleCreate = (params) => () => {
    polygonsService
      .postJefeTerritorio(params)
      .then((response) => {
        if (response.data.id === 0) {
          swal(swalMessages.ASSIGNMENT_ESTABLICHED);
        } else {
          getTerritoriesBosses();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /*= =======================================================================
  Eliminar Jefes y territirios
======================================================================== */
  const handleDeleteTableJefes = ({ rowData }) => {
    swal(swalMessages.DELETE_CONFIRM).then((willDelete) => {
      if (willDelete) {
        polygonsService
          .deleteJefesTabla(rowData)
          .then(() => {
            getTerritoriesBosses();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };

  const handleSelect = (item) => () => {
    setSelect(item);
  };

  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  const hadleSearchBoss = (event) => {
    setSearchBosses(event.target.value);
  };

  if (jefesTerritorios) {
    try {
      jefesTerritorios?.forEach((jefes) => {
        dataTable.push({
          territorio: jefes.territorio,
          territorio_id: jefes.territorio_id,
          jefe: jefes.jefe,
          jefe_id: jefes.jefe_id,
          unit: jefes.unidad_negocio_id,
        });
      });
    } catch (err) {
      console.log(err);
    }
  }

  const filtered = filterArray(territorios, 'territorio', search);
  const filteredBosses = filterArray(jefes, 'nombre', searchBosses);

  return (
    <>
      <BossesPage
        jefes={filteredBosses}
        jefesTerritorios={dataTable}
        permisos={permisos}
        territorios={filtered}
        select={select}
        onCreateBosses={handleCreateBosses}
        hadleSearchBoss={hadleSearchBoss}
        handleDeleteTable={handleDeleteTableJefes}
        handleDelete={handleDelete}
        handleUpdate={handleUpdate}
        handleCreate={handleCreate}
        handleSearch={handleSearch}
        handleSelect={handleSelect}
      />
    </>
  );
};

export default BossesContainer;
